<template>
  <div id="tags-filter">
    <Multiselect
      v-model="selectedTags"
      :options="customerTags"
      :placeholder="$t('tags.search_by')"
      :select-label="$t('tags.select_label')"
      :selected-label="$t('tags.selected_label')"
      :deselect-label="$t('tags.deselect_label')"
      :multiple="true"
      :max="3"
    >
      <template #maxElements>
        {{ $t('tags.max_message') }}
      </template>
      <template #noResult>
        {{ $t('tags.not_found_message') }}
      </template>
      <template #noOptions>
        {{ $t('tags.no_options') }}
      </template>
    </Multiselect>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import Multiselect from 'vue-multiselect';

export default {
  name: 'TagSearch',
  components: {
    Multiselect
  },
  computed: {
    ...mapState({
      customerTags: state => state.customerTags
    }),
    selectedTags: {
      get() {
        return this.$store.state.selectedTags;
      },
      set(value) {
        this.setSelectedTags(value);
      }
    }
  },
  watch: {
    selectedTags: {
      handler() {
        this.selectPage(1);
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations(['setSelectedTags']),
    ...mapActions(['selectPage'])
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
#tags-filter > div {
  z-index: 100;
}
</style>
